export default __webpack_public_path__ + "static/media/step_3_dont_2.c7be145c.jpg";